import { oneOf, shape, string } from 'prop-types'
import { ConfigSetAssignmentState } from '../../models/cold-chain/config-set-assignment-state-enum'

/**
 * @typedef {Object} ConfigSetAssignment
 * @property {string} configSetId
 * @property {string} state
 */

export const configSetAssignmentPropType = shape({
    configSetId: string.isRequired,
    state: oneOf(Object.values(ConfigSetAssignmentState)).isRequired
})
